import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/accordion';
import { FAQS } from '../mock';

export default function FAQ() {
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 py-20 sm:py-28 grid lg:grid-cols-12 gap-10">
      <div className="lg:col-span-4">
        <div className="text-xs uppercase tracking-[0.22em] text-[#245A40] font-semibold">FAQ</div>
        <h2 className="font-display text-4xl sm:text-5xl text-[#1B2A22] mt-3 leading-[1.05]">
          Everything you need <em className="italic">to know.</em>
        </h2>
        <p className="mt-5 text-[#3F4A42]">Got a different question? Call us at <a href="tel:7738570230" className="text-[#245A40] font-semibold">773-857-0230</a>.</p>
      </div>
      <div className="lg:col-span-8">
        <Accordion type="single" collapsible className="w-full">
          {FAQS.map((f) => (
            <AccordionItem key={f.q} value={f.q} className="border-b border-[#D6CFB8]">
              <AccordionTrigger className="text-left font-display text-xl text-[#1B2A22] py-6 hover:no-underline">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-[15px] text-[#3F4A42] leading-relaxed pb-6">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
